<!--
 * @Description:
 * @Date: 2020-08-06 17:18:31
-->
<template>
  <el-button
    type='primary'
    v-if='auditStatus !== 3'
    :disabled='ifDis || auditStatus === 1'
    @click='submit'
  >
    提交审核
  </el-button>
</template>
<script>
import { mapState } from 'vuex';
import { projectV2 } from '@/api/ajax';

export default {
  props: {
    auditStatus: {
      type: Number | String
    },
    ifDis: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      type: state => state.homeProject.type,
      projectType: state => state.homeProject.projectType
    })
  },
  methods: {
    async submit() {
      // 验证表单有无错误
      try {
        await this.$parent.validate();
      } catch (err) {
        return;
      }

      // 获取有无图片题
      const {
        data: {
          data: {
            tXcxProject: { isThereAPicture }
          }
        }
      } = await projectV2.loadProjectV2({
        id: this.projectId,
        projectType: this.projectType
      });

      // 弹出图片查重提示框
      if (
        +isThereAPicture === 1 && // 是否存在图片题
        +this.$parent.model.isCPicRepeat === 0 // 表单选项中，图片查重的值是否为 0
      ) {
        this.$confirm(
          '该项目问卷编辑中存在图片题，是否开启配置“C端图片查重”功能',
          '提示',
          {
            confirmButtonText: '开启',
            cancelButtonText: '跳过',
            type: 'warning'
          }
        )
          .then(() => {
            this.$message({
              type: 'success',
              message: '已开启图片查重',
              duration: 300
            });
            this.$parent.model.isCPicRepeat = 1;
            this.$emit('finish', this.type);
          })
          .catch(() => {
            this.$emit('finish', this.type);
          });
      } else {
        this.$emit('finish', this.type);
      }

      // this.$confirm("请您确认提交当前信息至后台审核，审核通过后您将可以继续执行项目。", "提示", {
      //   confirmButtonText: "确认提交",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     projectV2.submitProjectAudit({ id: this.projectId, type: this.type }).then(res => {
      //       this.$message({
      //         type: "success",
      //         message: "已提交审核"
      //       })
      //       this.$emit('sub')
      //     })
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消"
      //     })
      //   })
    }
  }
};
</script>
<style lang='scss' scoped></style>
